<script>
    import { fade } from 'svelte/transition';
    export let show =false;
    export let timeOutDuration = 3000;
    let timeout ;
    $:{
        if (show){
            if (timeout) clearTimeout(timeout);
            setTimeout(()=> show = false,timeOutDuration)
        }
    }

</script>

{#if show}
<div transition:fade
  style=" position: fixed; bottom: 0; z-index: 100; left: 0; margin: 10px auto;
  width: 100%; display: flex; justify-content: center; " on:click={()=> show = false}>

  <div class="notification is-primary" tabindex="0">
    <button aria-label="close notification" tabindex="0" class="delete" on:click={()=> show = false} 
     on:keypress={(e) => {if(e.keyCode == 13) show = false;}} />
    <slot/>
  </div>
</div>
{/if}